import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { OneModal } from '@factorialco/f0-react/dist/experimental'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import { useLocalStorage } from 'usehooks-ts'

import i18n from 'modules/core/lib/i18n'

import useChangeView from 'modules/shift_management/hooks/useChangeView'
import { COVERAGE_SECTION_HEIGHT } from 'modules/shift_management/lib/consts/ShiftManagementCoverage'

interface Props {
  onClose: () => void
  handleGenerateCoverage: () => void
}

const NoCoverageModal = ({ onClose, handleGenerateCoverage }: Props) => {
  const [, setLocalStorageResizeHeight] = useLocalStorage<number>(
    LOCAL_STORAGE_KEYS.shiftManagementCoverageResizeHeight,
    0
  )
  const { view, onChangeRoute } = useChangeView()

  const handleManually = () => {
    view.isByAreas && onChangeRoute(`${view.viewType}/employees`)
    setLocalStorageResizeHeight(COVERAGE_SECTION_HEIGHT)
    onClose()
  }
  return (
    <>
      <OneModal isOpen onClose={onClose} position="center">
        <OneModal.Header
          title={i18n.t('shift_management.coverage_section.automation.no_coverage_modal.title')}
        />
        <OneModal.Content>
          <Box padding="s20">
            <Text.Normal className="text-f1-foreground-secondary" whiteSpace="breakSpaces">
              {i18n.t('shift_management.coverage_section.automation.no_coverage_modal.description')}
            </Text.Normal>
          </Box>
        </OneModal.Content>
        <OneModal.Footer>
          <F0Button
            variant="outline"
            onClick={handleManually}
            size="md"
            label={i18n.t(
              'shift_management.coverage_section.automation.no_coverage_modal.add_button'
            )}
          />
          <F0Button
            label={i18n.t(
              'shift_management.coverage_section.automation.no_coverage_modal.generate_button'
            )}
            onClick={() => {
              handleGenerateCoverage()
            }}
            size="md"
            variant="default"
          />
        </OneModal.Footer>
      </OneModal>
    </>
  )
}

export { NoCoverageModal }
